import React, { useState } from 'react';
import { InstagramEmbed, YouTubeEmbed } from 'react-social-media-embed';
import Gallery from "./gallery.js";

import PC from "../images/Personal_Cloud.jpg";
import MP from "../images/Music_Player.jpg";
import Logo from "../images/logo.png";

import jp1 from "../images/Featured Work/1.jpg";
import jp2 from "../images/Featured Work/2.jpg";
import jp3 from "../images/Featured Work/3.jpg";
import jp4 from "../images/Featured Work/4.jpg";
import jp5 from "../images/Featured Work/5.jpg";
import jp6 from "../images/Featured Work/6.jpg";
import jp7 from "../images/Featured Work/7.png";
import jp8 from "../images/Featured Work/8.jpg";
import jp9 from "../images/Featured Work/9.jpg";
import jp10 from "../images/Featured Work/10.jpg";

export default function projects() {
	const images = [jp1, jp2, jp6, jp4, jp5, jp3, jp7, jp8, jp9, jp10];

	const galleryItems = [
		{ type: "youtube", url: "https://www.youtube.com/watch?v=AEVvrPWujXQ", classlist: "social-card yt " },
		{ type: "youtube", url: "https://www.youtube.com/watch?v=x2hcyAoU0yA", classlist: "social-card yt" },
		{ type: "instagram", url: "https://www.instagram.com/p/DSmDMGEE58f/", classlist: "social-card ig landscape" },
		{ type: "instagram", url: "https://www.instagram.com/p/DLHhCYnTSi-/", classlist: "social-card ig landscape" },
		{ type: "instagram", url: "https://www.instagram.com/p/DLcwSXfTBg-/", classlist: "social-card ig portrait" },
		{ type: "instagram", url: "https://www.instagram.com/p/DO3K7GBk5P3/", classlist: "social-card ig portrait" },
		{ type: "instagram", url: "https://www.instagram.com/p/DPLu-Ewk2-H/", classlist: "social-card ig portrait" },
	];

	const [activetab, setactivetab] = useState("codebuild");

	const handleactive = async (e) => {
		let target = e.currentTarget.getAttribute("data-target");

		document.getElementById(target).classList.toggle("active");
		document.getElementById(activetab).classList.toggle("active");
		setactivetab(target)
	};

	document.title = "Projects - Byokeh Studio";
	let metas = document.getElementsByTagName("meta");
	metas.description.content = ""

	return (
		<section className='projects container'>
			<div className="proj-heads">
				<h2 className={`feature-heads ${activetab === "codebuild" ? "active" : ""}`} data-target="codebuild" onClick={handleactive}>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-code-slash" viewBox="0 0 16 16">
						<path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0" />
					</svg>
					Software & Web Builds
				</h2>
				<h2 className={`feature-heads ${activetab === "visual" ? "active" : ""}`} data-target="visual" onClick={handleactive}>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-camera2" viewBox="0 0 16 16">
						<path d="M5 8c0-1.657 2.343-3 4-3V4a4 4 0 0 0-4 4" />
						<path d="M12.318 3h2.015C15.253 3 16 3.746 16 4.667v6.666c0 .92-.746 1.667-1.667 1.667h-2.015A5.97 5.97 0 0 1 9 14a5.97 5.97 0 0 1-3.318-1H1.667C.747 13 0 12.254 0 11.333V4.667C0 3.747.746 3 1.667 3H2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1h.682A5.97 5.97 0 0 1 9 2c1.227 0 2.367.368 3.318 1M2 4.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M14 8A5 5 0 1 0 4 8a5 5 0 0 0 10 0" />
					</svg>
					Visual Production
				</h2>
				<h2 className={`feature-heads ${activetab === "exp" ? "active" : ""}`} data-target="exp" onClick={handleactive}>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-person-lines-fill" viewBox="0 0 16 16">
						<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z" />
					</svg>
					Professional Experience
				</h2>
			</div>
			<div id='codebuild' className="proj-show-case active">
				<h2 className='feature-heads'>Web Development</h2>
				<div className="web-proj-cont">
					<div className="web-proj">
						<img src="https://raw.githubusercontent.com/Shuvadip-Ghosh/Groomify/refs/heads/master/screenshot.png" alt="" />
						<h3><a href="https://shuvadip-ghosh.github.io/Groomify/" target="_blank" rel="noopener noreferrer">Groomify</a></h3>
						<p>Groomify is a sleek and responsive website for pet grooming business.</p>
						<div className="proj-tags">
							<ul>
								<li>React Js</li>
								<li>Css</li>
							</ul>
						</div>
					</div>
					<div className="web-proj">
						<img src={PC} alt="" />
						<h3><a href="https://github.com/Shuvadip-Ghosh/My_world" target="_blank" rel="noopener noreferrer">Personal Cloud</a></h3>
						<p>A self-hosted backup solution that transforms my home server into a personal drive.</p>
						<div className="proj-tags">
							<ul>
								<li>Python (Flask)</li>
								<li>HTML</li>
								<li>Css</li>
							</ul>
						</div>
					</div>
					<div className="web-proj">
						<img src={MP} alt="" />
						<h3><a href="https://github.com/Shuvadip-Ghosh/My_world" target="_blank" rel="noopener noreferrer">ResoTune</a></h3>
						<p>A sleek, browser-based music player with smooth playback, intuitive controls, and playlist support.</p>
						<div className="proj-tags">
							<ul>
								<li>Python (Flask)</li>
								<li>HTML</li>
								<li>Css</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div id='visual' className="proj-show-case visual">
				<h2 className='feature-heads'>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
						<path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
					</svg>
					Photos
				</h2>
				<Gallery images={images} />
				<h2 className='feature-heads'>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
						<path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
					</svg>
					Videos
				</h2>
				<div className="social-gallery">
					{galleryItems.map((item, idx) => (
						<div key={idx} className={item.classlist}>
							{item.type === "youtube" && (
								<YouTubeEmbed url={item.url} width="100%" />
							)}
							{item.type === "instagram" && (
								<InstagramEmbed url={item.url} width="100%" placeholderImageUrl={Logo} />
							)}
						</div>
					))}
				</div>
			</div>
			<div id="exp" className="proj-show-case">
				<h2 className='feature-heads'>1. Sabar Institute — Web Developer Intern</h2>
				<p>2nd August 2025 - 11th Oct 2025 | Work-from-Home</p>
				<ul className='exp-points'>
					<li><strong>Redesigned and redeveloped the institute’s entire website</strong> to improve <strong>structure, responsiveness, and performance</strong>.</li>
					<li>Created multiple <strong>dynamic pages</strong> ensuring <strong>consistent design</strong> and smooth navigation across the site.</li>
					<li>Developed and integrated <strong>functional components</strong> such as <strong>contact forms, newsletter systems</strong>, and other interactive UI elements.</li>
					<li><strong>Optimized user experience (UX)</strong> by refining layouts, transitions, and <strong>accessibility features</strong>.</li>
					<li>Collaborated with the internal team to <strong>align design elements with brand identity</strong> and institutional goals.</li>
					<li>Ensured <strong>cross-browser compatibility</strong> and <strong>mobile-friendly responsiveness</strong> through iterative testing and feedback.</li>
				</ul>
				<h2 className='feature-heads'>2. Raksha 360 — Video Editor Intern</h2>
				<p>8th Sept 2025 – 8th Oct 2025 | Marketing Department | Work-from-Home</p>
				<ul className='exp-points'>
					<li><strong>Produced and edited multiple marketing videos</strong> within <strong>tight deadlines</strong>, meeting campaign requirements.</li>
					<li>Delivered <strong>high-quality, visually engaging content</strong> aligned with Raksha 360’s <strong>digital branding strategy</strong>.</li>
					<li>Worked closely with the marketing leadership team to ensure <strong>creative consistency</strong> across platforms.</li>
					<li><strong>Enhanced online presence</strong> through impactful video storytelling and strategic visual design.</li>
					<li>Demonstrated <strong>adaptability, creative problem-solving</strong>, and <strong>attention to detail</strong> under time constraints.</li>
					<li>Gained exposure to <strong>digital marketing strategies, content creation workflows</strong>, and <strong>social media analytics</strong>.</li>
				</ul>
				<h2 className='feature-heads'>3. Freelance — Web Developer &amp; Video Editor</h2>
				<p>Independent Projects (Ongoing)</p>
				<ul className='exp-points'>
					<li>Worked with individual clients and small businesses to deliver both <strong>web development</strong> and <strong>video editing</strong> solutions.</li>
					<li><strong>Designed and developed</strong> multiple <strong>responsive websites</strong></li>
					<li>Built and deployed <strong>interactive portfolios, small-scale web apps</strong>, and <strong>landing pages</strong> focused on <strong>usability and performance</strong>.</li>
					<li>Edited <strong>promotional videos, short films</strong>, and <strong>social media content</strong>, blending storytelling with <strong>visual rhythm</strong>.</li>
					<li>Delivered <strong>end-to-end project execution</strong> — from concept and design to development and post-production.</li>
					<li>Gained experience in <strong>client communication, time management</strong>, and <strong>cross-disciplinary project handling</strong>.</li>
				</ul>
			</div>
		</section>
	)
}
